import React from "react";
import Heading from "../../components/common/Typography/Heading";
import Paragraph from "../../components/common/Typography/Paragraph";
import SecondaryHeading from "../../components/common/Typography/SecondaryHeading";
import SpecialText from "../../components/common/Typography/SpecialText";
import {
  PUBLIC_HEADING_TO_CONTENT_CLASS,
  PUBLIC_ARTICLE_SECTION_GAP_CLASS,
  PUBLIC_ARTICLE_SUBSECTION_GAP_CLASS,
  PUBLIC_ARTICLE_PARAGRAPH_GAP_CLASS,
} from "../Public/shared/publicLayoutSpec";

const Article = () => {
  return (
    <>
      <div className="w-full">
        <Heading variant={"h1"} className={" text-offblack text-center"}>
          Blog title here
        </Heading>
        <div
          className={`w-full aspect-[1264/700] xl:h-[600px] 2xl:h-[700px] ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}
        >
          <img
            className="w-full h-full rounded-3xl object-cover"
            src={require("../../assets/img/default-image.jpg")}
            alt="trade-poster"
          />
        </div>
        <div>
          <div className={PUBLIC_ARTICLE_SECTION_GAP_CLASS}>
            <Paragraph variant={"MainParagraph"} className={"text-offblack"}>
              The services that an architect typically provides include concept
              design development, preparation of construction documents, and
              construction administration. Architects also provide a wide
              variety of additional services including feasibility studies,
              architectural programming and project management. The services
              that an architect typically provides include concept design
              development, preparation of construction documents, and
              construction administration. Architects also provide a wide
              variety of additional services including feasibility studies,
              architectural programming and project management. The services
              that an architect typically provides include concept design
              development, preparation of construction documents, and
              construction administration. Architects also provide a wide
              variety of additional services including feasibility studies,
              architectural programming and project management. The services
              that an architect typically provides include concept design
              development, preparation of construction documents, and
              construction administration. Architects also provide a wide
              variety of additional services including feasibility studies,
              architectural programming and project management. The services
              that an architect typically provides include concept design
              development, preparation of construction documents, and
              construction administration.
            </Paragraph>
          </div>
          <div className={PUBLIC_ARTICLE_SECTION_GAP_CLASS}>
            <Paragraph variant={"MainParagraph"} className={"text-offblack"}>
              The services that an architect typically provides include concept
              design development, preparation of construction documents, and
              construction administration. Architects also provide a wide
              variety of additional services including feasibility studies,
              architectural programming and project management. The services
              that an architect typically provides include concept design
              development, preparation of construction documents, and
              construction administration. Architects also provide a wide
              variety of additional services including feasibility studies,
              architectural programming and project management. The services
              that an architect typically provides include concept design
              development, preparation of construction documents, and
              construction administration. Architects also provide a wide
              variety of additional services including feasibility studies,
              architectural programming and project management.
            </Paragraph>
          </div>
          <div className={PUBLIC_ARTICLE_SECTION_GAP_CLASS}>
            <SecondaryHeading
              variant={"MainParagraphHeading"}
              className={"text-offblack"}
            >
              Heading 1
            </SecondaryHeading>
          </div>
          <div className={PUBLIC_ARTICLE_SUBSECTION_GAP_CLASS}>
            <Paragraph variant={"MainParagraph"} className={"text-offblack"}>
              The services that an architect typically provides include concept
              design development, preparation of construction documents, and
              construction administration. Architects also provide a wide
              variety of additional services including feasibility studies,
              architectural programming and project management. The services
              that an architect typically provides include concept design
              development, preparation of construction documents, and
              construction administration. Architects also provide a wide
              variety of additional services including feasibility studies,
              architectural programming and project management. The services
              that an architect typically provides include concept design
              development, preparation of construction documents, and
              construction administration. Architects also provide a wide
              variety of additional services including feasibility studies,
              architectural programming and project management. The services
              that an architect typically provides include concept design
              development, preparation of construction documents, and
              construction administration. Architects also provide a wide
              variety of additional services including feasibility studies,
              architectural programming and project management. The services
              that an architect typically provides include concept design
              development, preparation of construction documents, and
              construction administration.
            </Paragraph>
          </div>
          <div className={PUBLIC_ARTICLE_SECTION_GAP_CLASS}>
            <SecondaryHeading
              variant={"MainParagraphHeading"}
              className={"text-offblack"}
            >
              Heading 2
            </SecondaryHeading>
          </div>
          <div className={PUBLIC_ARTICLE_SUBSECTION_GAP_CLASS}>
            <Paragraph variant={"MainParagraph"} className={"text-offblack"}>
              The services that an architect typically provides include
            </Paragraph>
          </div>
          <ul className="list-inside list-decimal flex flex-col gap-3">
            <li className="pl-5">
              <Paragraph variant={"MainParagraph"} className={"text-offblack"}>
                The services that an architect typically provides include
                concept design development, preparation of construction
                documents, and construction administration. Architects also
                provide construction documents, and construction administration.
                Architects also provide a.
              </Paragraph>
            </li>
            <li className="pl-5">
              <Paragraph variant={"MainParagraph"} className={"text-offblack"}>
                The services that an architect typically provides include
                concept design development, preparation of construction
                documents, and construction administration. Architects also
                provide construction documents, and construction administration.
                Architects also provide a.
              </Paragraph>
            </li>
            <li className="pl-5">
              <Paragraph variant={"MainParagraph"} className={"text-offblack"}>
                The services that an architect typically provides include
                concept design development, preparation of construction
                documents, and construction administration. Architects also
                provide construction documents, and construction administration.
                Architects also provide a.
              </Paragraph>
            </li>
            <li className="pl-5">
              <Paragraph variant={"MainParagraph"} className={"text-offblack"}>
                The services that an architect typically provides include
                concept design development, preparation of construction
                documents, and construction administration. Architects also
                provide construction documents, and construction administration.
                Architects also provide a.
              </Paragraph>
            </li>
            <li className="pl-5">
              <Paragraph variant={"MainParagraph"} className={"text-offblack"}>
                The services that an architect typically provides include
                concept design development, preparation of construction
                documents, and construction administration. Architects also
                provide construction documents, and construction administration.
                Architects also provide a.
              </Paragraph>
            </li>
          </ul>
          <div className={PUBLIC_ARTICLE_SECTION_GAP_CLASS}>
            <SecondaryHeading
              variant={"MainParagraphHeading"}
              className={"text-offblack"}
            >
              Heading 3
            </SecondaryHeading>
          </div>
          <div className={PUBLIC_ARTICLE_SUBSECTION_GAP_CLASS}>
            <Paragraph variant={"MainParagraph"} className={"text-offblack"}>
              The services that an architect typically provides include
            </Paragraph>
          </div>
          <ul className="list-inside list-decimal flex flex-col gap-3">
            <li className="pl-5">
              <Paragraph variant={"MainParagraph"} className={"text-offblack"}>
                The services that an architect typically provides include
                concept design development, preparation of construction
                documents, and construction administration. Architects also
                provide construction documents, and construction administration.
                Architects also provide a.
              </Paragraph>
            </li>
            <li className="pl-5">
              <Paragraph variant={"MainParagraph"} className={"text-offblack"}>
                The services that an architect typically provides include
                concept design development, preparation of construction
                documents, and construction administration. Architects also
                provide construction documents, and construction administration.
                Architects also provide a.
              </Paragraph>
            </li>
            <li className="pl-5">
              <Paragraph variant={"MainParagraph"} className={"text-offblack"}>
                The services that an architect typically provides include
                concept design development, preparation of construction
                documents, and construction administration. Architects also
                provide construction documents, and construction administration.
                Architects also provide a.
              </Paragraph>
            </li>
            <li className="pl-5">
              <Paragraph variant={"MainParagraph"} className={"text-offblack"}>
                The services that an architect typically provides include
                concept design development, preparation of construction
                documents, and construction administration. Architects also
                provide construction documents, and construction administration.
                Architects also provide a.
              </Paragraph>
            </li>
          </ul>
          <div className={PUBLIC_ARTICLE_SECTION_GAP_CLASS}>
            <SpecialText
              variant={"ProfileName"}
              className={"text-offblack"}
            >
              Katy Vervack
            </SpecialText>
            <div
              className={`flex items-center justify-start space-x-2 ${PUBLIC_ARTICLE_PARAGRAPH_GAP_CLASS}`}
            >
              <div>
                <i className="fi fi-brands-facebook text-[16px] cursor-pointer"></i>
              </div>
              <div>
                <i className="fi fi-rr-share-alt-square text-[16px] cursor-pointer"></i>
              </div>
              <div className="size-4 cursor-pointer mb-[3px]">
                <img
                  src={
                    require("../../assets/img/social/twitter-alt.svg").default
                  }
                  alt="twitter"
                />
              </div>
              {/* <i className="fi fi-brands-twitter-alt text-base cursor-pointer"></i> */}
              <div>
                <i className="fi fi-brands-linkedin text-[16px] cursor-pointer"></i>
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Article;
